
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/people",
      function () {
        return require("private-next-pages/g/people/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/people"])
      });
    }
  